/**
 * @author       david.loehr@zumper.com (David Loehr)
 * @copyright    Copyright (c) 2025, Zumper
 */

import { APP_HOSTNAME } from '@zcode/nr-utils'
import { matchRoutes } from '@zcode/router-utils'
import { routes } from '@zcode/zumper-routes'
import type { Location } from 'history'

export const isWarmLoadableUrl = (url: string, location: Location) => {
  if (url[0] !== '/') {
    // a URL like https://www.zumper.com/whatever isn't warm-loadable on zumperrentals
    return false
  }
  if (url.startsWith('/zumper-account/') && !location.pathname.startsWith('/zumper-account/')) {
    // Fastly needs to see a GET /zumper-account/signin or GET /zumper-account/signup request
    // happen before the POST /zumper-account/signin or POST /zumper-account/signup request,
    // or it will reject the POST request
    return false
  }
  const { hash, pathname, search } = new URL(url, `https://${APP_HOSTNAME}/`)
  return !!matchRoutes(routes, { hash, pathname, search, state: undefined }).length
}
